import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../httpClient/RestApiService';


export type GetDataQualityTriggersForItemRequestParams = {
  readonly contentItemType: string;
  readonly contentItemLuid: string;
}

export function getGetDataQualityTriggersForItemRequestConfig(
  params: GetDataQualityTriggersForItemRequestParams
): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.10',
    httpMethod: 'GET',
    endpoint: `dataQualityTriggers/${params.contentItemType}/${params.contentItemLuid}`,
    serverWideRequest: false,
  };
}

export type DataQualityTriggerInfo = {
  readonly id: string;
  readonly contentId: string;
  readonly contentType: string;
  readonly message: string;
  readonly type: 'EXTRACT_REFRESH' | 'FLOW_RUN';
  readonly active: boolean;
  readonly severe: boolean;
}

/** The response actually has more fields but I'm only modeling what we're currently using */
export type GetDataQualityTriggersForItemResponse = {
  readonly dataQualityTriggerList: {
    readonly dataQualityTrigger: ReadonlyArray<DataQualityTriggerInfo>;
  };
};

export function callViaApiService(
  params: GetDataQualityTriggersForItemRequestParams
) {
  return makeJsonRestApiRequest<void, GetDataQualityTriggersForItemResponse>({
    config: getGetDataQualityTriggersForItemRequestConfig(params),
    request: null,
  });
}
